import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import classnames from 'classnames';

const Table = ({
  tableHeaders = [],
  tableBody = null,
  className,
  rowClass = 'flex space-between'
}) => {
  return (
    <div className={classnames('Table table-component', className)}>
      <div className="table-head">
        <div className={classnames('header-row', rowClass)}>
          {
            map(tableHeaders, header => (
              <div className={classnames('heavy', 'text-base', 'capitalize-first-letter', header.classname)} key={header.label}>
                {header.label}
              </div>
            ))
          }
        </div>
      </div>

      <div className="table-body">
        {tableBody}
      </div>
    </div>
  );
};

Table.propTypes = {
  tableHeaders: PropTypes.array,
  className: PropTypes.string,
  rowClass: PropTypes.string
};

export default Table;
